import { gql } from '@apollo/client';

export const USER_FIELDS_FRAGMENT = gql`
    fragment UserFields on User {
        Firstname
        Lastname
        Fullname
        UserId
        Phone
        Email
        Abbr
        UserState
        Access {
            Read
            Update
            Delete
            Create
        }
        Title
        UserState
        ProjectCount
        Created
        OwnOrganization {
            Name
            OrganizationId
        }
        LastUpdate
        OrganizationAdmin
        SystemAdmin
    }
`;

export const USER_WITH_IMAGE_FRAGMENT = gql`
    fragment UserFieldsWithImage on User {
        ...UserFields
        UserImage {
            FileId
        }
    }
    ${USER_FIELDS_FRAGMENT}
`;

export const USER_WORKPACKAGE_ROLE_TYPE_FRAGMENT = gql`
    fragment UserWorkPackageRoleTypeFields on UserWorkPackageRoleType {
        UserWorkPackageRoleTypeId
        Name
    }
`;

export const USER_IMAGE_FRAGMENT = gql`
    fragment UserImageFields on File {
        FileId
        FileData
        MimeType
    }
`;

export const USER_PROJECT_ROLE_TYPE_FRAGMENT = gql`
    fragment UserProjectRoleTypeFields on UserProjectRoleType {
        UserProjectRoleTypeId
        Name
    }
`;

export const USER_EPIC_ROLE_TYPE_FRAGMENT = gql`
    fragment UserEpicRoleTypeFields on UserEpicRoleType {
        UserEpicRoleTypeId
        Name
    }
`;

export const MINIMAL_USER_FIELDS_FRAGMENT = gql`
    fragment MinimalUserFields on User {
        UserId
        Firstname
        Lastname
    }
`;

export const FR_USER_AUTOCOMPLETE_FIELDS = gql`
    fragment fr_UserAutocompleteFields on User {
        UserId
        Firstname
        Lastname
        Fullname
        Phone
        Email
        OwnOrganization {
            OrganizationId
            Name
        }
    }
`;
